<div [formGroup]="form" class="c-form-field c-form-field--condition">
  <div class="c-form-field__radio-line" *ngIf="index !== 0"></div>
  <div class="c-form-field__fields">
    <div class="c-form-field__field">
      <p500-ui-select-field [container]="container" label="Payment System" [data]="conditionsData" [formControl]="getControlByKey('key')">
      </p500-ui-select-field>
    </div>
    <div class="c-form-field__field c-form-field__field--option">
      <p500-ui-select-field [container]="container" label="Sign" [data]="signsData" [formControl]="getControlByKey('operator')">
      </p500-ui-select-field>
    </div>
    <div class="c-form-field__field">
      <p500-ui-control-dynamic-component *ngIf="valueComponent" [component]="valueComponent.component" [settings]="valueComponent.settings">
      </p500-ui-control-dynamic-component>
    </div>
    <div class="c-form-field__delete">
      <button class="-remove-mobile" p500-ui-confluent-button size="small" type="button" color="warn" (click)="deleteCondition()">
        Remove
      </button>
      <button class="-remove-remove" p500-ui-circled-button size="medium" color="warn" [transparent]="true" (click)="deleteCondition()">
        <p500-ui-icon name="controls-close"></p500-ui-icon>
      </button>
    </div>
  </div>
</div>
